export const TEACH_DESC =
  "Easily create and turn your live classes and videos into a subscription income. Engage with your community, track analytics and much more! Edify is made for instructors, coaches and trainers who want to start their own subscription business using the best-in-class technology. ";

export const LEARN_DESC =
  "A world of content inside a single subscription. Instructor-led classes. Practice yoga and meditation. Recover from pregnancy. Get stronger, lose fat, and build muscle.";

export const TEACH_HEADING = "Train students with live classes";

export const LEARN_HEADING = "Learn from best of the instructors";

export const LEARN_MORE = "Learn more";
